// removed by extract-text-webpack-plugin
module.exports = {"Button":"ButtonIcon__Button__BBda-","Success":"ButtonIcon__Success__1-SFx","Gray":"ButtonIcon__Gray__6kEG0","Danger":"ButtonIcon__Danger__3Lyaf","Neutral":"ButtonIcon__Neutral__1rmQS","Small":"ButtonIcon__Small__1eIvv","ButtonText":"ButtonIcon__ButtonText__2MpUe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ButtonIcon/ButtonIcon.css
// module id = 316
// module chunks = 0